export default __webpack_public_path__ + "static/media/icon.f2d6615c.svg";